import CloseIcon from "@mui/icons-material/Close";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Box, IconButton, Typography } from "@mui/material";
import clsx from "clsx";
import React, { ChangeEvent, KeyboardEvent, RefObject } from "react";

import { AddOrderForm } from "../types";
import { useStyles } from "./styles";

type Props = {
  form: AddOrderForm;
  imageError: string;
  fileInputRef: RefObject<HTMLInputElement | null>;
  fieldLabel: (label: string) => string;
  uploadLabel: string;
  uploadHint: string;
  cancelLabel: string;
  onOpenFilePicker: () => void;
  onClearImage: (event: React.MouseEvent) => void;
  onFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onUploadKeyDown: (event: KeyboardEvent<HTMLDivElement>) => void;
};

const VehicleImageUpload = ({
  form,
  imageError,
  fileInputRef,
  fieldLabel,
  uploadLabel,
  uploadHint,
  cancelLabel,
  onOpenFilePicker,
  onClearImage,
  onFileChange,
  onUploadKeyDown,
}: Props) => {
  const styles = useStyles();

  return (
    <Box className={styles.imageField}>
      <Typography className={styles.label}>
        {fieldLabel("VEHICLE_IMAGE")}
      </Typography>
      <Box
        className={clsx(styles.uploadBox, imageError && styles.uploadBoxError)}
        role="button"
        tabIndex={0}
        onClick={onOpenFilePicker}
        onKeyDown={onUploadKeyDown}
      >
        {form.vehicleImage ? (
          <>
            <img
              src={form.vehicleImage}
              alt={form.vehicleImageName || fieldLabel("VEHICLE_IMAGE")}
              className={styles.uploadPreview}
            />
            <IconButton
              className={styles.removeImageButton}
              onClick={onClearImage}
              aria-label={cancelLabel}
            >
              <CloseIcon />
            </IconButton>
          </>
        ) : (
          <>
            <FileUploadOutlinedIcon className={styles.uploadIcon} />
            <Typography className={styles.uploadText}>{uploadLabel}</Typography>
            <Typography className={styles.uploadHint}>{uploadHint}</Typography>
          </>
        )}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/png,image/jpeg,.png,.jpg,.jpeg"
          hidden
          onChange={onFileChange}
          onClick={(event) => event.stopPropagation()}
        />
      </Box>
      {imageError ? (
        <Typography className={styles.uploadError}>{imageError}</Typography>
      ) : null}
    </Box>
  );
};

export default VehicleImageUpload;
